import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.9",
      d: "M5 5.75h10.25v8.75A4.25 4.25 0 0 1 11 18.75H9.25A4.25 4.25 0 0 1 5 14.5zM15.5 8.25h1.25a3.25 3.25 0 0 1 0 6.5H15.5"
    }, null, -1)
  ]))]))
}
export default { render: render }